import { Button } from 'primereact/button';
import React from 'react';
import { useNavigate, useRouteError } from 'react-router';

export const ErrorPage: React.FC = () => {
    const error = useRouteError() as Error;
    const navigate = useNavigate();

    return (
        <>
            <h1>Oops! Something went wrong</h1>
            <p>{error?.message || 'An unexpected error occurred'}</p>
            <Button onClick={() => window.location.reload()}>Refresh Page</Button>
            <Button onClick={() => navigate('/')}>Go to Home</Button>
        </>
    );
};
